/// <reference path="Assistant.ts" />

namespace TerminalApp {
    export class ItemParkingAssistant extends Assistant {
        select_type_menu = document.createElement("div");
        callback: (parked: boolean) => any;
        item: SP.ItemInfo;
        constructor() {
            super();
        
            this.select_type_menu.innerHTML = `
                <h1>${SP.Localize('sentance_select_period')}</h1>
                <div id="ipa_1_hour" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-clock-one"></i></div><div class="action">1 ${SP.Localize('word_hour')}</div></div>
                <div id="ipa_1_day" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-clock-two"></i></div><div class="action">1 ${SP.Localize('word_day')}</div></div>
                <div id="ipa_1_week" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-clock-three"></i></i></div><div class="action">1 ${SP.Localize('word_week')}</div></div>
                <div id="ipa_1_month" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-clock-four"></i></div><div class="action">1 ${SP.Localize('word_month')}</div></div>
                <div id="ipa_1_year" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-clock-five"></i></div><div class="action">1 ${SP.Localize('word_year')}</div></div>
                `;

            var ipa_1_hour = this.select_type_menu.querySelector("#ipa_1_hour");
            var ipa_1_day = this.select_type_menu.querySelector("#ipa_1_day");
            var ipa_1_week = this.select_type_menu.querySelector("#ipa_1_week");
            var ipa_1_month = this.select_type_menu.querySelector("#ipa_1_month");
            var ipa_1_year = this.select_type_menu.querySelector("#ipa_1_year");

            ipa_1_hour.addEventListener("click", () => { this.parkItem(1); });
            ipa_1_day.addEventListener("click", () => { this.parkItem(1 * 24); });
            ipa_1_week.addEventListener("click", () => { this.parkItem(1 * 24 * 7); });
            ipa_1_month.addEventListener("click", () => { this.parkItem(1 * 24 * 30); });
            ipa_1_year.addEventListener("click", () => { this.parkItem(1 * 24 * 365); });

            this.container.appendChild(this.select_type_menu);
        }

        async parkItem(hours: number) {
            this.item.refillParked = hours > 0;
            await SP.get(`/api/v1/item/parkRefill/${this.item.id}?hours=${hours}`)
            if (this.callback)
            this.close();
        }

        hide() {
            this.container.style.display = "none";
            this.select_type_menu.style.display = "none";
        }

        open_select_type() {
            this.hide();
            this.container.style.display = "block";
            this.select_type_menu.style.display = "block";
        }

        async open(item: SP.ItemInfo, callback: (parked: boolean) => any) {
            this.item = item;
            this.callback = callback;

            //unpark
            if (item.refillParked) {
                this.parkItem(-1);
            }
            else { 
                this.open_select_type();
            }

        }

        close() {
            this.callback(this.item.refillParked);
            super.close();
        }
    }
}